import { apiCall } from "./service";
import {
    URL_RUNBOOKS,
    URL_RUNBOOK,
    URL_RUNBOOK_START,
    URL_RUNBOOK_STOP,
    URL_RUNBOOK_ACTIONS,
    URL_RUNBOOK_ACTION,
    URL_RUNBOOK_ACTION_COMPLETE,
    URL_RUNBOOK_DUPLICATE,
    URL_RUNBOOK_ACTION_DUPLICATE,
    URL_RUNBOOK_ACTION_REORDER,
} from "./URL";

export const api = {
    getRunbooksRequest(params) {
        const { projectId, status, searchTerm, page, size } = params;
        const queryParams = { pageNumber: page, pageSize: size };
        if (projectId) queryParams.projectId = projectId;
        if (status !== undefined && status !== null && status !== "") queryParams.status = status;
        if (searchTerm) queryParams.searchTerm = searchTerm;
        const qs = new URLSearchParams(queryParams).toString();
        return apiCall.pagination({ url: `${URL_RUNBOOKS}?${qs}` });
    },

    getRunbookDetailRequest(id) {
        return apiCall.get({ url: URL_RUNBOOK(id) });
    },

    createRunbookRequest(payload) {
        return apiCall.post({ url: URL_RUNBOOKS, params: payload });
    },

    updateRunbookRequest({ id, payload }) {
        return apiCall.put({ url: URL_RUNBOOK(id), params: payload });
    },

    deleteRunbookRequest(id) {
        return apiCall.delete({ url: URL_RUNBOOK(id) });
    },

    startRunbookRequest(id) {
        return apiCall.post({ url: URL_RUNBOOK_START(id), params: {} });
    },

    stopRunbookRequest(id) {
        return apiCall.patch({ url: URL_RUNBOOK_STOP(id), params: {} });
    },

    getRunbookActionDetailRequest({ runbookId, actionId }) {
        return apiCall.get({ url: URL_RUNBOOK_ACTION(runbookId, actionId) });
    },

    createRunbookActionRequest({ runbookId, payload }) {
        return apiCall.post({ url: URL_RUNBOOK_ACTIONS(runbookId), params: payload });
    },

    updateRunbookActionRequest({ runbookId, actionId, payload }) {
        return apiCall.put({ url: URL_RUNBOOK_ACTION(runbookId, actionId), params: payload });
    },

    deleteRunbookActionRequest({ runbookId, actionId }) {
        return apiCall.delete({ url: URL_RUNBOOK_ACTION(runbookId, actionId) });
    },

    completeRunbookActionRequest({ runbookId, actionId }) {
        return apiCall.patch({ url: URL_RUNBOOK_ACTION_COMPLETE(runbookId, actionId), params: {} });
    },
    duplicateRunbookRequest({ id, payload }) {
        return apiCall.post({ url: URL_RUNBOOK_DUPLICATE(id), params: payload ?? {} });
    },

    duplicateRunbookActionRequest({ runbookId, actionId }) {
        return apiCall.post({ url: URL_RUNBOOK_ACTION_DUPLICATE(runbookId, actionId), params: {} });
    },

    reorderRunbookActionRequest({ runbookId, actionId, payload }) {
        return apiCall.patch({ url: URL_RUNBOOK_ACTION_REORDER(runbookId, actionId), params: payload });
    },

    updateRunbookFlagRequest(params) {
        return apiCall.patch({
            url: URL_RUNBOOK(params.id),
            params: params.payload,
        });
    },
    patchRunbookActionRequest(params) {
        return apiCall.patch({
            url: URL_RUNBOOK_ACTION(params.runbookId, params.actionId),
            params: params.payload,
        });
    },
    getRunbookExportRequest(id, params) {
        const queryParams = Object.entries(params)
            .filter(([_, value]) => value !== null && value !== undefined)
            .map(
                ([key, value]) =>
                    `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
            )
            .join("&");

        const url = `${`${URL_RUNBOOK(id)}/export`}${queryParams ? `?${queryParams}` : ""}`;
        return apiCall.getFile({
            url,
            headers: {
                Accept:
                    "text/csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "Content-Type": "blob",
            },
            responseType: "arraybuffer",
        });
    },
    getRunbookReportRequest(params) {
        let url = `${URL_RUNBOOK(params.id)}/report`;
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        var paylaod = { tz: timezone };

        return apiCall.pdfPost({ url: url, params: paylaod });
    },
};

export default api;
